// Editorial Promo
// Vyrabi promo pro redakce do inzertnich pozic pro uzivatele, kteri odmitnou reklamu

export const EditorialPromo = (): void => {
  window.editorialPromo = (magazine: string, position: string) => {
    const fragment = new DocumentFragment();

    const wrapper = document.createElement('div');
    wrapper.classList.add(
      'editorial-promo',
      `editorial-promo--position-${position}`,
      `editorial-promo--magazine-${magazine}`
    );
    wrapper.style.backgroundImage = `url(/dist/assets/${magazine}/editorial-promo/editorial-promo-${position}.png)`;
    fragment.append(wrapper);

    const agreeButton = document.createElement('a');
    const buttonClasses = [
      'editorial-promo__agree',
      'button',
      position === '311' && magazine === 'zeny' ? 'button--outlined' : 'button--contained',
      position === '322-mobile' ? 'button--sm' : 'button--md',
    ];

    agreeButton.className = buttonClasses.join(' ');
    agreeButton.style.whiteSpace = 'nowrap';
    agreeButton.href = 'javascript:void(0)';
    agreeButton.onclick = function () {
      window.Didomi.notice?.show();
      return false;
    };

    const textSpan = document.createElement('span');
    textSpan.className = 'button__text';
    textSpan.innerText = 'Souhlasit';
    agreeButton.appendChild(textSpan);

    wrapper.append(agreeButton);

    if (magazine !== 'zeny') {
      const noAdsButton = document.createElement('a');
      noAdsButton.classList.add('editorial-promo__noads', 'button', 'button--outlined');
      noAdsButton.classList.add(position === '311' ? 'button--md' : 'button--sm');
      noAdsButton.innerText = position === '322-mobile' ? 'Chci web BEZ REKLAM' : 'Web BEZ REKLAM';
      noAdsButton.style.whiteSpace = 'nowrap';
      noAdsButton.href = '/predplatne';
      wrapper.append(noAdsButton);
    }

    return fragment;
  };
};

export default EditorialPromo;
